/**
 * DevExtreme (esm/__internal/scheduler/utils/is_scheduler_component.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
const schedulerComponentName = "dxScheduler";
export function isSchedulerComponent(component) {
  return "dxScheduler" === component.NAME;
}